import { Box, LinearProgress, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Document, PDFViewer, Page, View } from '@react-pdf/renderer';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as ROUTES from '../../../router/Routes';
import Modal from '../../../widgets/modals/Modal';
import ContainerTemplate from '../../../widgets/template/Container';
import { stylesDocPdf } from '../../pdfs';
import FooterPdf from '../../pdfs/FooterPdf';
import TablaRecibosPdf from './pdf/RecibosPdf';

// Create Document Component
const RecibosPdf = () => {
  const recibosStore = Redux.useSelector((state) => state.recibos);

  const [loadingDoc, setLoadingDoc] = React.useState(true);

  return (
    <ContainerTemplate
      active={ROUTES.recibosPdf}
      routes={[ROUTES.controlEstudios, ROUTES.recibos]}
    >
      <Grid container spacing={1}>
        <Grid item md={12}>
          <PDFViewer
            style={{
              width: '100%',
              height: '80vh',
              zIndex: 50,
            }}
            showToolbar={true}
          >
            <Document title={'Recibos'} onRender={() => setLoadingDoc(false)}>
              <Page size="A4" style={stylesDocPdf.page}>
                {/* <FooterPdf /> */}
                <View
                  style={{ flex: 1, ...stylesDocPdf.section, margin: '20pt' }}
                >
                  <TablaRecibosPdf data={recibosStore.all} />
                </View>
                <FooterPdf />
              </Page>
            </Document>
          </PDFViewer>
        </Grid>
        <Modal open={loadingDoc}>
          <Box sx={{ width: '100%' }}>
            <Typography variant="h6" sx={{ textAlign: 'center' }}>
              Generando lista...
            </Typography>
            <LinearProgress />
          </Box>
        </Modal>
      </Grid>
    </ContainerTemplate>
  );
};

export default RecibosPdf;
